import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-public-sidebar',
  templateUrl: './public-sidebar.component.html',
  styleUrls: ['./public-sidebar.component.css']
})
export class PublicSidebarComponent implements OnInit {

  collapseShow = "hidden";

  constructor() { }

  ngOnInit(): void {
  }

  toggleCollapseShow(classes) {
    this.collapseShow = classes;
  }

}
